export const durationApiToUiHours = 60 * 60;

export function convertDurationToUi(
    value: number,
    businessDayLengthHours?: number | null,
): number | null {
    if (typeof value !== 'number') {
        return null;
    }
    if (businessDayLengthHours) {
        return (value || 0) / (durationApiToUiHours * businessDayLengthHours);
    }
    return (value || 0) / durationApiToUiHours;
}
